export function shouldDisableTracking(options = {}) {
    const { disabled, portal } = options;
    if (disabled || (portal === null || portal === void 0 ? void 0 : portal.eueiEnabled) === false) {
        return true;
    }
    if (!portal || hasEueiEnabledAndIsMemberOfOrg(portal) || isRegisteredUserWithoutOrgInUSA(portal) || isAnonymousUserInUSA(portal)) {
        return false;
    }
    return true;
}
function hasEueiEnabledAndIsMemberOfOrg(portal) {
    return portal.eueiEnabled && portal.user && portal.user.orgId === portal.id;
}
function isRegisteredUserWithoutOrgInUSA(portal) {
    return portal.user && !portal.user.orgId && portal.ipCntryCode === 'US';
}
function isAnonymousUserInUSA(portal) {
    return !portal.user && portal.ipCntryCode === 'US';
}
//# sourceMappingURL=should-disable-tracking.js.map